import { Container, Box, Typography, Button, Grid } from '@mui/material';
import { getImageUrl } from '../../utils';

const CancerfondenAdvert = () => (
  <Box sx={{ background: 'linear-gradient(to bottom,rgb(255, 255, 255), #ffffff)', py: { xs: 6, md: 8 } }}>
    <Container maxWidth="md">
      <Box
        sx={{
          background: 'rgba(255, 255, 255, 0.6)',
          backdropFilter: 'blur(8px)',
          borderRadius: '1rem',
          boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
          p: { xs: 3, md: 5 },
        }}
      >
        <Grid container spacing={4} alignItems="center">
          {/* Image */}
          <Grid item xs={12} md={4}>
            <Box display="flex" justifyContent="center">
              <img
                src={getImageUrl('pink-logo.png')}
                alt="Cancerfonden Logo"
                style={{
                  maxWidth: '210px',
                  height: 'auto',
                  borderRadius: '12px',
                  boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
                }}
              />
            </Box>
          </Grid>

          {/* Content */}
          <Grid item xs={12} md={8}>
            <Typography
              variant="h5"
              sx={{
                fontFamily: 'var(--font-heading)',
                fontWeight: 700,
                color: '#C2185B',
                textAlign: { xs: 'center', md: 'left' },
                mb: 1,
              }}
            >
              Insamling till Cancerfonden
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: '#444',
                fontSize: '1rem',
                textAlign: { xs: 'center', md: 'left' },
                mb: 3,
              }}
            >
              Pilates Höganäs samlar in pengar till Cancerfonden i minne av Birgitta Möller.
            </Typography>

            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                gap: 2,
                justifyContent: { xs: 'center', md: 'flex-start' },
                alignItems: 'center',
              }}
            >
              <Button
                variant="contained"
                href="https://www.cancerfonden.se/insamlingar/pilates-hoganas-samlar-in-pengar-till-cancerfonden-i-minne-av-birgitta-moller"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  backgroundColor: '#333',
                  color: '#fff',
                  borderRadius: '999px',
                  px: 3,
                  py: 1,
                  fontWeight: 500,
                  fontSize: '0.95rem',
                  textTransform: 'none',
                  '&:hover': {
                    backgroundColor: '#666',
                  },
                }}
              >
                Läs mer om insamlingen
              </Button>
              <Button
                variant="contained"
                href="https://www.cancerfonden.se/stod-oss/skank-till-en-insamling/pilates-hoganas-samlar-in-pengar-till-cancerfonden-i-minne-av-birgitta-moller"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  backgroundColor: '#DD0D7D',
                  color: '#fff',
                  borderRadius: '999px',
                  px: 3,
                  py: 1,
                  fontWeight: 600,
                  fontSize: '0.95rem',
                  textTransform: 'none',
                  '&:hover': {
                    backgroundColor: '#E98FBF',
                  },
                }}
              >
                Bidra till insamlingen
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Container>
  </Box>
);

export default CancerfondenAdvert;
